import React, { forwardRef, useMemo } from 'react';

import { generateTimestampedUrl } from 'rcx_adapter/src/util';
import i18n from 'rcx_i18n';

import { StyledRCXIFrame } from './RCX.styled';
import Config from '../../config/app.config';
import { RCX_IFRAME_WIDTH } from '../constants';

interface Props {
    agentUIUrl?: string;
}

// eslint-disable-next-line react/display-name
export const RCXIFrame = forwardRef<HTMLIFrameElement, Props>(({ agentUIUrl }, ref) => {
    const src = useMemo(() => generateTimestampedUrl(agentUIUrl || Config.agentUIUrl), [agentUIUrl]);
    return (
        <StyledRCXIFrame
            ref={ref}
            id='ringcx-cti'
            allow='microphone *'
            src={src}
            title={i18n.t('rcx_iframe_title')}
            width={RCX_IFRAME_WIDTH}
        />
    );
});

RCXIFrame.displayName = 'RCXIFrame';
